import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon, HeartIcon } from 'lucide-react';
const forItems = ['Mamás con bebés de 4 a 24 meses que despiertan más de 3 veces por noche.', 'Mujeres que sufren de ansiedad por falta de sueño y agotamiento crónico.', 'Padres que no quieren usar métodos crueles de "dejar llorar".', 'Familias que trabajan y necesitan que el bebé duerma para poder rendir al día siguiente.'];
const notForItems = ['Padres de recién nacidos (menores de 3 meses).', 'Personas que buscan una solución "mágica" sin aplicar la rutina constante.', 'Casos de condiciones médicas respiratorias o neurológicas severas.'];
export function WhoIsForSection() {
  return <section className="w-full" data-id="element-203">
      {/* FOR section - dark bg */}
      <div className="bg-gradient-to-b from-[#0f172a] to-[#1e293b] py-16 md:py-20" data-id="element-204">
        <div className="max-w-4xl mx-auto px-4" data-id="element-205">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-206">
            <div className="flex items-center justify-center gap-3 mb-10" data-id="element-207">
              <HeartIcon className="w-8 h-8 text-[#22c55e]" data-id="element-208" />
              <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-white text-center" data-id="element-209">
                Esto Es Para Ti Si...
              </h2>
            </div>

            <ul className="space-y-4" data-id="element-210">
              {forItems.map((item, index) => <motion.li key={index} className="flex items-start gap-4 bg-[#22c55e]/10 border border-[#22c55e]/30 p-5 rounded-xl" initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} data-id="element-211">
                  <div className="w-6 h-6 bg-[#22c55e] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-212">
                    <CheckIcon className="w-4 h-4 text-white" data-id="element-213" />
                  </div>
                  <p className="font-['DM_Sans'] text-gray-200 text-lg" data-id="element-214">
                    {item}
                  </p>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>

      {/* NOT FOR section - cream bg */}
      <div className="bg-[#f5f0e8] py-16 md:py-20" data-id="element-215">
        <div className="max-w-4xl mx-auto px-4" data-id="element-216">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-217">
            <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#64748b] text-center mb-10" data-id="element-218">
              Esto NO Es Para Ti Si...
            </h2>

            <ul className="space-y-4" data-id="element-219">
              {notForItems.map((item, index) => <motion.li key={index} className="flex items-start gap-4 bg-white/60 border border-[#94a3b8]/30 p-5 rounded-xl" initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} data-id="element-220">
                  <div className="w-6 h-6 bg-[#94a3b8] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-221">
                    <XIcon className="w-4 h-4 text-white" data-id="element-222" />
                  </div>
                  <p className="font-['DM_Sans'] text-[#64748b] text-lg" data-id="element-223">
                    {item}
                  </p>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}